<template>
    <div class="bonus-info" v-if="isPayloadPresent || isExternalIncentiveAvailable">
        <template v-if="isPayloadPresent">
            <strong class="card-text">{{ $t('externalIncentive.alreadyFetched.title') }}</strong>

            <template v-if="isRegularPayload">
                <p class="card-text" v-if="incentiveText1" v-html="incentiveText1"></p>
                <p class="card-text" v-else>{{ $t('externalIncentive.alreadyFetched.string.notice') }}</p>
                <div class="card-navigation">
                    <div>
                        <pre @click="copyToClipboard">{{ payloadData }}</pre>
                    </div>
                    <div>
                        <small v-if="copied">{{ $t('externalIncentive.alreadyFetched.string.copied')}}</small>
                        <small v-else>{{ $t('externalIncentive.alreadyFetched.string.copy')}}</small>
                    </div>
                </div>
                <p class="card-text" v-if="incentiveText2" v-html="incentiveText2"></p>
            </template>
            <template v-else-if="isDownloadPayload">
                <p class="card-text">{{ $t('externalIncentive.alreadyFetched.download.notice') }}</p>
                <div class="card-navigation">
                    <a class="btn btn-secondary btn-sm" :href="buttonLink" target="_blank">
                        {{ $t('externalIncentive.alreadyFetched.download.button') }}
                    </a>
                </div>
            </template>
            <template v-else>
                <p class="card-text">{{ $t('externalIncentive.alreadyFetched.notice') }}</p>
                <div class="card-navigation">
                    <a class="btn btn-secondary btn-sm" :href="buttonLink" target="_blank">
                        {{ $t('externalIncentive.alreadyFetched.button') }}
                    </a>
                </div>
            </template>
        </template>
        <template v-else-if="isExternalIncentiveAvailable">
            <strong class="card-text">{{ $t('externalIncentive.title') }}</strong>
            <p class="card-text">{{ $t('externalIncentive.notice') }}</p>
            <div class="card-navigation">
                <a class="btn btn-secondary btn-sm" :href="buttonLink" target="_blank">
                    {{ $t('externalIncentive.button') }}
                </a>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'ExternalIncentiveBlock',
    props: {
        incentiveData: {
            type: Object,
            default: null
        },
        code: String,
        link: {
            type: String,
            default: process.env.VUE_APP_EXTERNAL_INCENTIVE_URL
        },
        queryParam: {
            type: String,
            default: "?code="
        }
    },
    data () {
        return {
            copied: false
        }
    },
    computed: {
        buttonLink: function() {
            if (this.isDownloadPayload) {
                return this.payloadData;
            }
            return this.link + this.queryParam + this.code;
        },
        payloadData: function() {
            return this.incentiveData.externalIncentivePayload.value;
        },
        incentiveText1: function() {
            return this.incentiveData.incentiveText1;
        },
        incentiveText2: function() {
            return this.incentiveData.incentiveText2;
        },
        isPayloadPresent: function() {
            return this.incentiveData && this.incentiveData.externalIncentivePayload;
        },
        isDownloadPayload: function() {
            return this.isPayloadPresent && this.incentiveData.externalIncentivePayload.type === "Download";
        },
        isPostalShipmentPayload: function() {
            return this.isPayloadPresent && this.incentiveData.externalIncentivePayload.type === "PostalShipment";
        },
        isRegularPayload: function() {
            return this.isPayloadPresent && this.incentiveData.externalIncentivePayload.type === "String";
        },
        isExternalIncentiveAvailable: function() {
            return this.incentiveData && this.incentiveData.externalIncentiveAvailable;
        }
    },
    methods: {
        copyToClipboard() {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(this.payloadData);
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 3000);
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .bonus-info {
        border: 1px solid #999;
        padding: .6rem 1.25rem;
        margin-top: 1.25rem;

        .card-navigation {
            justify-content: center;
            align-items: center !important;
            flex-direction: column;

            p {
                margin-bottom: 0;
            }

            a.btn {
                margin-bottom: .6rem;
            }

            pre {
                cursor: pointer;
                font-weight: bold;
                font-size: 120%;
                background: #fff;
                padding: 5px 15px;
                border: 1px solid #000;
                margin: 0;
            }
        }
    }
</style>